import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { AbstractCrudComponent } from '../../component/abstract-crud.component';
import { ErrorDialogComponent } from '../../dialogs/error-dialog/error-dialog.component';
import { HistoricoEventoDTO } from '../../dtos/historico-evento-dto';
import { ChaveValorStrInterface } from '../../util/chave-valor-str-interface';
import { Util } from '../../util/util';
import { CustomDateValidator } from '../../validators/custom-date-validator';
import { HistoricoEvento } from '../historico-evento';
import { HistoricoEventoService } from '../historico-evento.service';

@Component({
  selector: 'app-historico-evento-list',
  templateUrl: './historico-evento-list.component.html',
  styleUrls: ['./historico-evento-list.component.css']
})
export class HistoricoEventoListComponent extends AbstractCrudComponent {

  displayedColumns: string[] = ['data', 'usuario', 'menuFormatado', 'eventoFormatado', 'complemento'];

  formularioDeConsultaDeHistoricoDeEventos: FormGroup;

  filtroHistoricoEvento: HistoricoEventoDTO;

  public listaMenusSistema: ChaveValorStrInterface[];

  public listaEventosSistema: ChaveValorStrInterface[];

  constructor(private historicoEventoService: HistoricoEventoService, router: Router, dialog: MatDialog,
    private formBuilder: FormBuilder) {

    super(router, dialog);

    this.filtroHistoricoEvento = history.state.filtroPaciente;

    this.formularioDeConsultaDeHistoricoDeEventos = this.formBuilder.group({
      usuario: ['', [Validators.minLength(3)]],
      dataEventoInicial: [''],
      dataEventoFinal: [''],
      evento: [''],
      menu: [''],
    }, {
      validator: [CustomDateValidator('dataEventoInicial'),
      CustomDateValidator('dataEventoFinal')],
    });

    this.listaMenusSistema = Util.listaMenusSistema;

    this.listaEventosSistema = Util.listaEventosSistema;
  }

  ngOnInit() {

    if (this.filtroHistoricoEvento && (this.filtroHistoricoEvento.usuario ||
      this.filtroHistoricoEvento.evento || this.filtroHistoricoEvento.menu ||
      (this.filtroHistoricoEvento.dataEventoInicial && this.filtroHistoricoEvento.dataEventoFinal))) {

      this.formularioDeConsultaDeHistoricoDeEventos.setValue(this.filtroHistoricoEvento);

      this.reloadData(this.filtroHistoricoEvento);
    }

    super.ngOnInit();
  }

  reloadData(filtro: HistoricoEventoDTO) {

    if (!filtro.usuario && !filtro.evento && !filtro.menu && (!filtro.dataEventoInicial || !filtro.dataEventoFinal)) {

      this.dialog.open(ErrorDialogComponent, {
        data: {
          title: 'Erro',
          message: 'Selecione pelo menos um campo de filtro!'
        }
      });

    } else {

      this.historicoEventoService.procurarHistoricoEventoPorFiltro(filtro)
        .subscribe(data => {
          // console.log(data)

          const listaHistoricoEvento: Array<HistoricoEvento> = [];

          data.forEach((element: any) => {
            listaHistoricoEvento.push(

              HistoricoEvento.fromClasse(Object.assign(new HistoricoEvento(), element)));
          });

          this.data = listaHistoricoEvento;

          this.configurarDataSource();
        }, error => {
          console.log(error);
        });

    }
  }

  onSubmit() {
    this.filtroHistoricoEvento = this.formularioDeConsultaDeHistoricoDeEventos.value;

    this.reloadData(this.filtroHistoricoEvento);
  }
}
